import { useMemo, useState } from 'react';
import { useField, observer } from '@formily/react';
import { ArrayField } from '@formily/core';
import classNames from 'classnames';
import { QuestionConfig } from '../../types/feelgood';
import ComponentStore from '../../store';
import { defaultTextPlaceHolder } from '../../common/const';
import styles from './style.module.less';

/**
 * matrix
 */
export default observer(() => {
  const field = useField<ArrayField>();
  const questionConfig: QuestionConfig = field.data;
  const { defaultText } = ComponentStore.useContext();
  const tableColumnData = useMemo(() => {
    return questionConfig.matrixData?.subOptionTitle;
  }, [questionConfig.matrixData]);
  const tableRowData = useMemo(() => {
    return questionConfig.matrixData?.subQuestionList;
  }, [questionConfig.matrixData]);
  field.setValidator(val => {
    if (
      questionConfig.matrixData?.isRequired &&
      val?.filter((i: string) => i !== defaultTextPlaceHolder).length !==
        tableRowData?.length
    ) {
      return defaultText?.is_require;
    }
    return true;
  });
  const [radioVal, setRadioVal] = useState<Record<number, string | undefined>>(
    {},
  );
  return (
    <div className={styles.matrix}>
      <div className={styles.column}>
        <div className={styles.columnItemEmpty}></div>
        {tableColumnData?.map((column, index) => {
          return (
            <div className={styles.columnItem} key={index} title={column}>
              <div className={styles.text}>{column}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.row}>
        {tableRowData?.map((row, index) => {
          return (
            <div key={index} className={styles.rowRadioGroup}>
              <div className={styles.rowTitle} title={row.titleText}>
                <div className={styles.text}> {row.titleText}</div>
              </div>
              {row.optionKeyList.map((key: string) => {
                return (
                  <label
                    key={key}
                    className={classNames(
                      styles['single-choice-item-label'],
                      radioVal[index] === key
                        ? styles['single-choice-item-label-click']
                        : '',
                    )}
                    onClick={() => {
                      let selectVal = field.value;
                      if (selectVal.length === 0) {
                        selectVal = new Array(
                          questionConfig.matrixData?.subQuestionList?.length ||
                            0,
                        ).fill(defaultTextPlaceHolder);
                      }
                      setRadioVal({
                        ...radioVal,
                        [index]: key,
                      });
                      selectVal.splice(index, 1, key);
                      field.setValue([...selectVal]);
                      field.validate().catch((e: any) => e);
                    }}
                  >
                    <span
                      className={styles['single-choice-item-label-circle']}
                    ></span>
                  </label>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
});
